import { CustomerConfigEditorEnvService } from '@aipb/gulliver/customer-config-editor/env';
import { BaseRouting } from '@aipb/routing';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CustomerConfigEditorRouting extends BaseRouting {
  static APP_ROUTE = 'customer-config-editor';

  static configPath = ':configId';

  constructor(customerConfigEditorEnv: CustomerConfigEditorEnvService) {
    super(
      ['/' + CustomerConfigEditorRouting.APP_ROUTE, CustomerConfigEditorRouting.configPath],
      customerConfigEditorEnv
    );
  }
}
